import {EActiveCondition} from '../model/types';

/**
 * Определяет, должно ли действие быть disabled (неактивным)
 * на основе условия активности и выбранных строк таблицы.
 *
 * @param {EActiveCondition} activeCondition - Условие активности, определяющее логику проверки.
 * @param {number[]} selectedTableRows - Массив идентификаторов выбранных строк таблицы.
 * @returns {boolean} - Возвращает boolean значение для подстановки в пропс disabled айтема меню.
 * `true`, если действие должно быть disabled (неактивным), и `false` в противном случае.
 *
 * @description
 * Функция проверяет, должно ли действие быть заблокировано, на основе переданного условия активности:
 * - `ActiveCondition.ALWAYS`: Действие всегда активно (возвращает `false`).
 * - `ActiveCondition.ONE_ROW_ONLY`: Действие активно только при выборе ровно одной строки.
 * - `ActiveCondition.ANY_ROWS`: Действие активно при наличии любой выбранной строки.
 * - Для неизвестных условий возвращает `false` (по умолчанию).
 */
export const activeConditionResolver = (activeCondition: EActiveCondition, selectedTableRows: number[]): boolean => {
    switch (activeCondition) {
    case EActiveCondition.ALWAYS: {
        return false;
    }
    case EActiveCondition.ONE_ROW_ONLY: {
        return selectedTableRows.length !== 1;
    }
    case EActiveCondition.ANY_ROWS: {
        return selectedTableRows.length === 0;
    }
    default: {
        return false;
    }
    }
};
